import React from 'react';
import AppLogo from '@/components/ui/AppLogo';
import Link from 'next/link';
import { Cog6ToothIcon } from '@heroicons/react/24/outline';

interface PageHeaderProps {
  title?: string;
  showAdmin?: boolean;
}

export default function PageHeader({ title, showAdmin = false }: PageHeaderProps) {
  return (
    <header className="sticky top-0 z-40 bg-secondary/95 backdrop-blur-sm border-b border-white/10">
      <div className="flex items-center justify-between px-4 py-3 max-w-lg mx-auto">
        <Link href="/" className="flex items-center gap-2">
          <AppLogo size={32} />
          <span className="font-bold text-sm text-secondary-foreground leading-tight">
            {title || (
              <>
                New Forest<br />
                <span className="text-primary">Family Fun Day</span>
              </>
            )}
          </span>
        </Link>
        {showAdmin && (
          <Link
            href="/admin-panel"
            className="p-2 rounded-lg text-secondary-foreground/60 hover:text-primary hover:bg-white/10 transition-all duration-200"
            aria-label="Admin panel"
          >
            <Cog6ToothIcon className="w-5 h-5" />
          </Link>
        )}
      </div>
    </header>
  );
}